import 'array.prototype.fill';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
//import 'core-js/modules/es6.symbol';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Css from './components/bper-css';


export default function BPERMapApplication({ config }) {
	//import css only if is not production server
	return (
		<>
			{
				!MODE_PRODUCTION && <Css />
			}
			<App portlet="search" config={config} />
		</>
	);
}

function BPERCardsApp({config}) {
	return <>
		{
			!MODE_PRODUCTION && <Css />
		}
		<App portlet="closest" config={config} />
	</>
}

const MODE_PRODUCTION = process.env.NODE_ENV === 'production';

window.BPERLocator = {
	async setup(element, config) {
		function renderApp(AppComponent) {
			ReactDOM.render(<AppComponent config={config} />, element);
		}
		renderApp(BPERMapApplication);
	}
};

window.BPERCards = {
	async setup(element, config) {
		function renderApp(AppComponent) {
			ReactDOM.render(<AppComponent config={config} />, element);
		}
		renderApp(BPERCardsApp);
	}
};

if (!MODE_PRODUCTION) {
	window.BPERLocator.setup(document.getElementById('root'), {
		groupId: 20143,
		abicode: "05387",
		language: "it",
		currentRegion: "",//
		currentProvince: "",//698214
		currentSubsidiary: "",//2857
		locale:true
	});
	
	window.BPERCards.setup(document.getElementById('root2'), {
		groupId: 20143,
		abicode: "05387",
		language: "it",
		currentSubsidiary: "6559",//
		locale: true
	});
}